import ActiveOptionViewState, { ActiveItem } from '../../store/schema/ActiveOptionViewState';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import loadConversationViewOption from '../../actions/conversationView/loadConversationViewOption';
import { ConversationViewState } from '../../store/schema/ConversationViewState';
import { getOptionsStore } from '../../store/Store';
import { mutator } from 'satcheljs';

const loadConversationViewOptionMutator = mutator(loadConversationViewOption, () => {
    const userOptions = getUserConfiguration().UserOptions;
    const activeViewState: ConversationViewState = {
        name: ActiveItem.ConversationView,
        isDirty: false,
        isLoading: false,
        globalListViewTypeReact: userOptions.GlobalListViewTypeReact,
        conversationSortOrderReact: userOptions.ConversationSortOrderReact,
    };

    getOptionsStore().activeViewState = activeViewState as ActiveOptionViewState;
});

export default loadConversationViewOptionMutator;
